// src/pages/BundeslandNordrheinWestfalen.jsx
import React from "react";
import BundeslandPage from "./BundeslandPage";
import { nordrheinWestfalen } from "../components/states/nordrhein-westfalen";

export default function BundeslandNordrheinWestfalen() {
  return <BundeslandPage data={nordrheinWestfalen} />;
}

